export enum AnalyticsEvent {
  SignedIn = 'Signed In',
  FinanceApplicationRepaymentTermsSubmitted = 'Finance Application Repayment Terms Submitted',
  FinanceApplicationEligibilitySubmitted = 'Finance Application Eligibility Submitted',
  FinanceApplicationIdentificationSubmitted = 'Finance Application Identification Submitted',
  FinanceApplicationHouseholdDetailsSubmitted = 'Finance Application Household Details Submitted',
  FinanceApplicationIncomeVerificationSubmitted = 'Finance Application Employment Details Submitted',
  FinanceApplicationBusinessDetailsSubmitted = 'Finance Application Business Details Submitted',
  FinanceApplicationOwnershipDetailsSubmitted = 'Finance Application Ownership Details Submitted',
  FinanceApplicationBeneficialOwnerSubmitted = 'Finance Application Beneficial Owner Submitted',
  FinanceApplicationPaymentDetailsSubmitted = 'Finance Application Payment Details Submitted',
  FinanceApplicationSent = 'Finance Application Sent',
}

export const CUSTOMER_APPLICATION_SOURCE = 'Customer Application';
